import { useEffect, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router";

export interface RedirectProps {
  to: string;
}

export const Redirect: React.FC<RedirectProps> = ({ to }) => {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const redirected = useRef(false);

  useEffect(() => {
    if (redirected.current) return;
    if (params.has("authUser") && params.get("authUser") !== null) return;

    navigate(to, { replace: true });
    redirected.current = true;
  }, [navigate, to, params]);
  return null;
};
